import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { ArtistState } from "explorer/reducers/artistas";

const Revelator: React.FC<RouteComponentProps> = () => {
  const { distroToken } = useSelector((state: ArtistState) => state.artists);

  if (!distroToken) {
    return <div>Não há token de distribuição</div>;
  }

  return (
    <iframe
      title="revelator"
      src={`${process.env.REACT_APP_REVELATOR_SITE}authorize?token=${distroToken}`}
      width="100%"
      height="100%"
    ></iframe>
  );
};

export default Revelator;
